import { render, staticRenderFns } from "./provideImageDialog3.vue?vue&type=template&id=0cbdc5ed&scoped=true&"
import script from "./provideImageDialog3.vue?vue&type=script&lang=js&"
export * from "./provideImageDialog3.vue?vue&type=script&lang=js&"
import style0 from "./provideImageDialog3.vue?vue&type=style&index=0&id=0cbdc5ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdc5ed",
  null
  
)

export default component.exports